<script setup lang="ts">
import { Dropdown } from "floating-vue";
import type { PropType } from "vue";

import Icon from "@/components/Icon.vue";
import type { NavigationItem } from "@/types";

const props = defineProps({
  menu: { type: Array as PropType<Array<NavigationItem>>, default: () => [] },
});
</script>

<template>
  <Dropdown :distance="6">
    <!-- This will be the popover reference (for the events and position) -->
    <slot name="button">
      <button>
        <slot />
      </button>
    </slot>

    <!-- This will be the content of the popover -->
    <template #popper="{ hide }">
      <slot name="menu">
        <div
          class="min-w-[8rem] rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden"
        >
          <slot name="header" />
          <div>
            <template v-for="item in props.menu" :key="item.key">
              <div v-if="item.divider" class="border-t" />
              <router-link
                v-else-if="item.to"
                v-close-popper
                :to="item.to"
                :class="[
                  'flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900',
                ]"
                v-bind="
                  item.callback
                    ? {
                        ...(item.attrs ?? {}),
                        onClick: (e: Event) => {
                          item.callback(e);
                          hide();
                        },
                      }
                    : (item.attrs ?? {})
                "
              >
                <Icon
                  v-if="item.icon"
                  v-bind="typeof item.icon === 'string' ? { name: item.icon } : item.icon"
                  class="h-4 w-4"
                  aria-hidden="true"
                />
                <span>{{ item.name }}</span>
              </router-link>
              <button
                v-else-if="item.callback"
                v-close-popper
                v-bind="item.attrs ?? {}"
                :class="[
                  'flex w-full items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900',
                ]"
                @click="
                  ($event) => {
                    hide();
                    item.callback($event);
                  }
                "
              >
                <Icon
                  v-if="item.icon"
                  v-bind="typeof item.icon === 'string' ? { name: item.icon } : item.icon"
                  class="h-4 w-4"
                  aria-hidden="true"
                />
                <span>{{ item.name }}</span>
              </button>
              <span
                v-else
                v-bind="item.attrs ?? {}"
                :class="[
                  'flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900',
                ]"
              >
                <Icon
                  v-if="item.icon"
                  v-bind="typeof item.icon === 'string' ? { name: item.icon } : item.icon"
                  class="h-4 w-4"
                  aria-hidden="true"
                />
                <span>{{ item.name }}</span>
              </span>
            </template>
          </div>
          <slot name="footer" />
        </div>
      </slot>
    </template>
  </Dropdown>
</template>
